var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function Container(_a) {
    var children = _a.children;
    return (_jsx("div", __assign({ className: cn("flex flex-col items-center justify-center w-full h-full py-5 px-4 gap-6", "md:px-6 md:pr-10 py-6") }, { children: children })));
}
